import React from "react";
import { useParams, Navigate } from "react-router-dom";

/**
 * @returns {React.ReactElement} Redirect to team overview
 */
export default function TeamDetail() {
  const { orgId, teamId } = useParams();

  return <Navigate to={`/orgs/${orgId}/teams/${teamId}/overview`} />;
}
